import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import EntitiesModal from '@ey/canvascoreservices/EntitiesModal';
import Env from '../../../util/env';
import Utility from '../../../util/utilityfunctions';
import {currentResource} from '../../../util/utils';
import {Entity, serviceURL} from '../../../util/uiconstants';
import {clearErrors} from '../../../actions/erroractions';
import CreateEditEntityModal from './CreateEditEntityModal';
import ErrorSummary from '../ErrorSummary/ErrorSummary';
import {setIsADCModalOpen} from '../../../actions/setismodalopen';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';

export default function EntitiesModalWrapper(props) {
	const {
		engagementId,
		entityType,
		entities,
		getAllAction,
		getByIdAction,
		onClose,
		show,
		setShow,
		deleteAction,
		isManageEntities,
		serverSidePagination,
		isITGC,
		additionalColumnDef,
		secondaryBtnClick
	} = props;

	const entitySpecificLabels =
		entityType === Entity.ITControl
			? isITGC
				? currentResource.EntitiesLabels[entityType].ITGC
				: currentResource.EntitiesLabels[entityType].ITSP
			: currentResource.EntitiesLabels[entityType];

	const [editEntityId, setEditEntityId] = useState(null),
		[showCreateEditEntityModal, setShowCreateEditEntityModal] = useState(false),
		[paginationParamsForServerCall, setPaginationParamsForServerCall] = useState({});
	const dispatch = useDispatch();

	const onDeleteServerSideEntity = () => {
		let isLastRecordFromLastPage =
			paginationParamsForServerCall?.page === entities?.pages &&
			entities?.data?.length === 1 &&
			paginationParamsForServerCall?.page > 1;
		switch (entityType) {
			case Entity.SampleItem:
				if (isLastRecordFromLastPage) {
					dispatch(
						getAllAction({
							...paginationParamsForServerCall,
							page: paginationParamsForServerCall.page - 1,
							includePagination: true
						})
					);
				} else {
					dispatch(
						getAllAction({
							...paginationParamsForServerCall,
							includePagination: true
						})
					);
				}
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		if (show) {
			dispatch(setIsADCModalOpen(true));
		}
		return () => {
			dispatch(setIsADCModalOpen(false));
			dispatch(clearErrors());
			dispatch(setFormV2ToasterVisibility(false));
		};
	}, []);

	return (
		<StyledEntitiesModalWrapper className="StyledEntitiesModalWrapper">
			<EntitiesModal
				engagementId={engagementId}
				entityType={entityType}
				showModal={show}
				setShowModal={setShow}
				theme={Utility.getTheme()}
				labels={currentResource.EntitiesLabels}
				entitySpecificLabels={entitySpecificLabels}
				baseUrl={`${Env.getBaseURL(serviceURL, engagementId)}`}
				getAllAction={getAllAction}
				getByIdAction={getByIdAction}
				selector={entities}
				deleteAction={deleteAction}
				onCloseModalCallback={() => {
					dispatch(clearErrors());
					onClose?.();
				}}
				onDeleteModalClose={() => dispatch(clearErrors())}
				editEntity={(id) => {
					setEditEntityId(id);
					setShowCreateEditEntityModal((prev) => !prev); // toggle modal state
				}}
				onCreateClick={() => {
					setEditEntityId(null);
					setShowCreateEditEntityModal(true);
				}}
				serverSidePagination={serverSidePagination}
				setIsEntityUpdated={props.setIsEntityUpdated}
				errorComponent={<ErrorSummary />} // this for getting the error message in the delete modal (if any API error occurs)
				additionalColumnDef={additionalColumnDef}
				onSecondaryBtnClick={secondaryBtnClick}
				setPaginationParamsForServerCall={setPaginationParamsForServerCall}
				onDeleteServerSideEntity={onDeleteServerSideEntity}
			/>
			<CreateEditEntityModal
				engagementId={engagementId}
				entityType={entityType}
				entityId={editEntityId}
				showCreateEditEntityModal={showCreateEditEntityModal}
				setShowCreateEditEntityModal={setShowCreateEditEntityModal}
				isManageEntities={isManageEntities}
				isITGC={isITGC}
				setIsEntityUpdated={props.setIsEntityUpdated}
				onEntityCreated={props.onEntityCreated}
				paginationParamsForServerCall={paginationParamsForServerCall}
				{...props}
			/>
		</StyledEntitiesModalWrapper>
	);
}

EntitiesModalWrapper.propTypes = {
	engagementId: PropTypes.number,
	entityType: PropTypes.number,
	getAllAction: PropTypes.func,
	getByIdAction: PropTypes.func,
	onClose: PropTypes.func,
	show: PropTypes.bool.isRequired,
	setShow: PropTypes.func,
	deleteAction: PropTypes.func
};

const StyledEntitiesModalWrapper = styled.section`
	.motif-table {
		height: var(--px-500);
	}
`;
